// extracted by mini-css-extract-plugin
export default {"extensionUpsellBanner":"ExtensionUpsellBanner_extensionUpsellBanner__Yg1nU"};